import React, {forwardRef} from 'react';
import Currency from "../Currency/Currency";
import {FormattedMessage} from "react-intl";

import './PayoutDistributionTable.style.scss'
import useDeviceType from "../../hooks/useDeviceType";
import {useSelector} from "react-redux";
import {selectLocale} from "../../stores/account/account.selectors";
import _ from "lodash";

const PayoutDistributionTable = forwardRef(({parlayName, entryFee, extraTitle, payoutInfos, currency, showProgressive, preSelectedParlayBannerHeight, reLayoutHeight}, ref) => {

    const locale = useSelector(selectLocale);

    preSelectedParlayBannerHeight = isNaN(preSelectedParlayBannerHeight) ? 666 : preSelectedParlayBannerHeight;

    const isPrizeAsset = _.last(payoutInfos)?.prizeAsset != null;
    let tableHeight = Math.min(Math.max(isPrizeAsset ? preSelectedParlayBannerHeight *.70 : preSelectedParlayBannerHeight-30, 475), 800);
    let topNBottomPadding = 30;
    let headerHeight = 32;
    let tableRowContentHeight = tableHeight - headerHeight - topNBottomPadding;
    let tableRowHeight = tableRowContentHeight / payoutInfos.length;
    const {isMobile} = useDeviceType();

    return (
        <div ref={ref} className="PayoutDistributionTable" style={reLayoutHeight ? {height: tableHeight} : {}}>
            {parlayName && <h1 className={`parlayName`}>{parlayName}</h1>}
            <h1 className={`header gold-gradient-text`}>{extraTitle} <FormattedMessage id={'popUp.payOut.payout'}/></h1>
            {entryFee && <h3 className={`entryFee`}><FormattedMessage id={'popUp.payOut.entryFee'}/><Currency value={entryFee} currency={currency} removeDecimal/></h3>}
            <table className="payoutTable" style={{height: tableRowContentHeight}}>
                <tbody>
                {payoutInfos.map((p, index) => {
                    const isPaid = p.payout > 0 || index === payoutInfos.length - 1;
                    let isLast = index === payoutInfos.length - 1;
                    return(
                    <tr key={index} className="tableRow" style={{height: tableRowHeight}}>
                        <td  className={`correctNumber _${index} ${p.payout > 0 ? "highlight gold-gradient-text" : ""} ${p.correct < 10 ? " belowTen" : ""}`}>
                            {p.correct} <FormattedMessage id={'popUp.payOut.correct'}/>
                        </td>

                        {p.prizeAsset ?
                            <td className={`payoutAmount prizeAsset _${index} ${p.prizeAsset ? "highlight" : ""}`}>
                                <div className="gold-gradient-text">{p.prizeAsset["Name"+ _.capitalize(locale)]} (<Currency value={p.prizeAsset.Value}
                                                                                                                            currency={p.prizeAsset.Currency}
                                                                                                                            toK={p.prizeAsset.Value >= 1000}
                                                                                                                            removeDecimal className="gold-gradient-text" />)</div>
                            </td>
                                      : <td className={`payoutAmount _${index} ${p.payout > 0  ? "highlight gold-gradient-text" : ""}`}>
                            {index === payoutInfos.length - 1 && showProgressive ? (
                                <><Currency value={p.payout}
                                              currency={currency}
                                              className={isPaid ? "gold-gradient-text" : ""}
                                              removeDecimal
                                /> + <FormattedMessage id={`popUp.payOut.${isMobile? 'prog' : 'progressive'}`}/></>
                            ) : (
                                <Currency value={p.payout}
                                          currency={currency}
                                          className={isPaid ? "gold-gradient-text" : ""}
                                          removeDecimal={!isLast}
                                />
                            )}
                        </td>}
                    </tr>
                )})}
                </tbody>
            </table>
        </div>
    )
});

export default PayoutDistributionTable;